import { type CookieSerializeOptions } from "cookie";
import { add } from "date-fns";
import { cookieExpiresDutaion } from "./const";

export const cookieConsentOptions = (): CookieSerializeOptions => {
  return { expires: add(new Date(), cookieExpiresDutaion) };
};
